<template>
  <div class="about-features">
    <ul>
      <li>We only analyze messages from first time senders</li>
      <li>We will never send or delete messages for you</li>
      <li>If we find spam or cold outreach, we will only label and archive them</li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "AboutFeatures"
});
</script>

<style scoped>
.about-features {
  flex: 1;
  text-align: left;
}

.about-features ul {
  list-style: none;
  padding: 0;
}

.about-features li {
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
}

.about-features li::before {
  content: "•";
  color: var(--primary-color);
  font-size: 1.5em;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style> 